import { useQuery } from '@tanstack/react-query'
import { BoosterProgramStats } from 'Modules'

import { AppAdmin } from 'api/app-admin'
import { logError } from 'utils/logger'

import { boosterProgramKeys } from './query-keys'

const EMPTY_STATS: BoosterProgramStats = {
  totalPrograms: 0,
  totalEnrolledUsers: 0,
  totalCodesIssued: 0,
  totalCodesApplied: 0,
}

const fetchStats = async (): Promise<BoosterProgramStats> => {
  try {
    const res = await AppAdmin.getBoosterProgramStats()
    if (!res.data?.success || !res.data.data) return EMPTY_STATS
    return res.data.data
  } catch (error) {
    logError('Error fetching booster program stats:', error)
    return EMPTY_STATS
  }
}

export const useBoosterProgramStats = () => {
  const query = useQuery({
    queryKey: boosterProgramKeys.stats(),
    queryFn: fetchStats,
  })

  return {
    stats: query.data ?? EMPTY_STATS,
    isLoading: query.isLoading,
  }
}
